import { stringify } from 'querystring';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

const generateNaturalLanguageSearchUrl = (nlq: string, languageRegionCode: LanguageRegionCode) => {
  const stringifiedParams = stringify({ nlq });
  const searchParams = new URLSearchParams(stringifiedParams);
  const route = wrapUrlSafe(`/explore?${decodeURIComponent(searchParams.toString())}`, languageRegionCode);
  return route;
};

export default generateNaturalLanguageSearchUrl;
